import { createSlice } from "@reduxjs/toolkit";

const initalFilterState = {
    filterType: 'all'
}

const filterSlice = createSlice({
    name: 'filter',
    initialState: initalFilterState,
    reducers:{
        filterType(state,action) {
            state.filterType = action.payload;
        }
    }
});

export const filterActions = filterSlice.actions;

export default filterSlice.reducer;